// extracted by mini-css-extract-plugin
module.exports = {"Card":"Card__Card___1Il9c","Footer":"Card__Footer___gVDTE","Body":"Card__Body___LgddR"};